import { CountryState } from './index';
import { MutationTree } from 'vuex';

export default {
    setCountries(state: CountryState, countries) {
        state.countries = countries;
    },
    isInitialized(state: CountryState) {
        state.isInitialized = true;
    }
} as MutationTree<CountryState>
